<template>
	<div>
		<div
			:id="divName"
			:name="name"
			:mapType="mapType"
			:latitude="latitude"
			:longitude="longitude"
			:zoom="zoom"
			:style="{width: this.width, height: this.height}"
		/>
	</div>
</template>
<script>
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {initializeOlMap} from "../../plugins/ol/OlAnuket";

export default {
	name: "OlMapContainer",
	props: {
		name: {
			type: String,
			required: true,
			default: "olMap",
		},
		mapType: {
			type: String,
			required: true,
			default: "osm",
		},
		latitude: {
			type: String,
			required: false,
			default: "51.51455",
		},
		longitude: {
			type: String,
			required: false,
			default: "-0.07306",
		},
		zoom: {
			type: String,
			required: false,
			default: 12,
		},
		width: {
			type: String,
			required: false,
			default: "100vw",
		},
		height: {
			type: String,
			required: false,
			default: "100vh",
		},
	},
	data() {
		return {
			olMap: null,
			vectorLayer: null,
			geoJsonObject: {
				type: "FeatureCollection",
				crs: {
					type: "name",
				},
				features: [],
			},
		};
	},
	computed: {
		divName() {
			return this.name;
		},
	},
	mounted() {
		this.vectorLayer = new VectorLayer({
			source: new VectorSource({
				features: [],
			}),
		});
		const options = {
			mapType: this.mapType,
			vectorLayer: this.vectorLayer,
			controls: {
				streetView: false,
				zoom: true,
				fullScreen: true,
			},
			geolocation: false,
			lat: this.latitude,
			lng: this.longitude,
			zoom: this.zoom,
		};
		this.olMap = initializeOlMap(this.divName, options);
		this.loadMap();
	},
	methods: {
		loadMap() {
			this.$emit("instanceOlMap", {
				ol: this.olMap,
				vec: this.vectorLayer,
			});
		},
	},
};
</script>
